import formActions from "../utils/common-form-actions";
let currentSection
let keys = []

const renderSteps = (modal, activeSection) => {
    modal.find('.sidebar ul li[data-section]').removeClass('active').removeAttr('aria-current')
        .filter(`[data-section="${activeSection}"]`).addClass('active').attr('aria-current', 'step')
    modal.find('.mobile-header ul li[data-section]').removeClass('active').removeAttr('aria-current')
        .filter(`[data-section="${activeSection}"]`).addClass('active').attr('aria-current', 'step')

    const sections = modal.find('form.edit-group-form .form-group[data-section]');
    sections.addClass('hidden')
    sections.filter(`[data-section="${activeSection}"]`).removeClass('hidden')

    const prevIndex = keys.indexOf(activeSection) - 1;
    const nextIndex = keys.indexOf(activeSection) + 1;
    const next = keys[nextIndex]
    const prev = keys[prevIndex]

    const isUpdatingGroup = modal.find('#editgroup-group_id').val()
    const footer = modal.find('.modal-footer')
    footer.find('.btn-back')[prev ? 'removeClass' : 'addClass']('hidden')
    // Always show next in mobile
    // if (window.innerWidth < 992) {
    //     if (next) {
    //         footer.find('.btn-send').removeClass('hidden')
    //         footer.find('.btn-save').addClass('hidden');
    //     }
    // } else
    if (isUpdatingGroup && next && window.innerWidth >= 992) {
        footer.find('.btn-send').removeClass('hidden')
        footer.find('.btn-save').removeClass('hidden');
    } else if (next) {
        footer.find('.btn-send').removeClass('hidden')
        footer.find('.btn-save').addClass('hidden');
    } else {
        footer.find('.btn-send').addClass('hidden');
        footer.find('.btn-save').removeClass('hidden')
    }

    footer.find('[data-section]').addClass('hidden').filter(`[data-section="${activeSection}"]`).removeClass('hidden')
    footer.find('[data-before-section]').addClass('hidden')
        .filter(() => !!next).filter(`[data-before-section="${next}"]`).removeClass('hidden')
    footer.find('[data-after-section]').addClass('hidden')
        .filter(() => !!prev).filter(`[data-after-section="${prev}"]`).removeClass('hidden')
    footer.find('[data-op]:not(.hidden)').addClass('hidden').filter(`[data-op=${isUpdatingGroup ? "update" : "insert"}]`).removeClass('hidden')

    modal.find('.sidebar ul li[data-section]').removeClass('clickable').off('click');
    modal.find('.sidebar ul li[data-section]').each(function () {
        const index = $(this).data('section');
        if (isUpdatingGroup || index < activeSection) {
            $(this).addClass('clickable').on('click', function () {
                currentSection = index;
                renderSteps(modal, index);
            });
        }
    });
    modal.trigger('coing.steps.changed', activeSection)
    modal.data('currentSection', activeSection)
    modal.find('form').parent().scrollTop(0)
}

export default context => {
    $('#EditGroupForm', context).each(function () {
        const $form = $(this)
        $('[data-section-container]', $form).each(function () {
            const container = $(this)
            const section = container.data('section-container')
            if (!section) {
                return
            }
            $form.find(`[data-section="${section}"]`).not(container.parents('[data-section]')).detach().appendTo(container)

        })

        if ($form.closest('#EditGroupModal.steps').length) {
            const $modal = $form.closest('#EditGroupModal')

            keys = []
            $modal.find('.sidebar ul li[data-section]').each(function () {
                const index = $(this).data('section');
                if ($form.find(`.form-group[data-section="${index}"]`).length > 0) {
                    keys.push(index)
                } else {
                    $modal.find(`.mobile-header ul li[data-section="${index}"]`).remove();
                    $(this).remove();
                }
            });
            currentSection = keys[0]
            $modal.find('.mobile-header .total').text(keys.length)
            const percents = Math.floor(1 / keys.length * 100)
            $modal.find('.mobile-header .pie-wrapper').removeClass().addClass(`pie-wrapper progress-${percents}`);
            renderSteps($modal, currentSection);

            $modal.find('.btn-save').on('click', function () {
                const form = $('.edit-group-form')
                const value = $(this).val() || ''
                form.on('submitting.coing', function(e, data) {
                    data.append('buttonAction', value)
                })
                form.trigger('submit', 'close');
            })
            // $modal.find('.btn-submit').on('click', function () {
            //     $('.edit-group-form').trigger('submit', 'continue');
            // })
            $modal.find('.btn-send').on('click', function () {
                const nextIndex = keys.indexOf(currentSection) + 1;
                if (!keys[nextIndex]) {
                    $modal.find('.btn-save').trigger('click')
                    return false
                }
                const form = $modal.find('form.edit-group-form');
                formActions.cleanForm(form);
                const formData = new FormData(form[0]);
                formData.append('cid', cid);
                if ($(this).hasClass('btn-send')) {
                    formData.append('onlyValidate', true);
                }
                spinner.show();
                $modal.find(`.form-group[data-section][data-section!="${currentSection}"]`).find('input,select,textarea').each(function() {
                    formData.delete($(this).attr('name'))
                })
                $.ajax({
                    url: '/site/groups/validate-group',
                    data: formData,
                    processData: false,
                    contentType: false,
                    type: 'post'
                }).done(function (data) {
                    console.debug('done')
                    if (data.success) {
                        currentSection = keys[nextIndex];
                        $modal.find('.mobile-header .current').text(nextIndex + 1);
                        const percents = parseInt((nextIndex + 1) / keys.length * 100);
                        $modal.find('.mobile-header .pie-wrapper').removeClass().addClass(`pie-wrapper progress-${percents}`);
                        renderSteps($modal, currentSection);
                    } else {
                        formActions.applyFormErrors(
                            form,
                            data.errors || {},
                            '#{field}',
                            '.form-group,.edit-container',
                            (field, $field, $container, message) => {
                                const ticketContainer = $field.closest('tbody.ticket-form-item')
                                if (ticketContainer.length) {
                                    $container = ticketContainer.find('tr.errors-container td:first')
                                }
                                const $errorp = $(`<p id="${field}-error" class="help-block help-block-error">`).text(message);
                                $container.append($errorp);
                                $field.attr('aria-describedby', field + '-error');
                            })
                            .then(() => {
                                window.openAlert(data.message || '', 'error');
                                form.find('.has-error :visible:focusable:first').focus();
                            });
                    }
                }).statusCode({
                    413: content => {
                        console.debug('413')
                        window.openAlert(translate.errors.images_too_large, 'error')
                    },
                }).fail(function () {
                    console.debug('fail')
                    window.openAlert(getCommonError(), 'error');
                }).always(function () {
                    console.debug('always')
                    spinner.remove();
                });
            });
            $modal.find('.btn-back').on('click', function () {
                const prevIndex = keys.indexOf(currentSection) - 1;
                if (keys[prevIndex]) {
                    currentSection = keys[prevIndex];
                    $modal.find('.mobile-header .current').text(prevIndex + 1);
                    const percents = Math.floor((prevIndex + 1) / keys.length * 100);
                    $modal.find('.mobile-header .pie-wrapper').removeClass().addClass(`pie-wrapper progress-${percents}`);
                    renderSteps($modal, currentSection);
                }
            });
        }

        $('#editgroup-starts_at', $form).on('change', function () {
            const button = $(this).closest('.edit-dialog').find('.modal-footer .btn-save-recurring')
            const subtitle = $(this).closest('.edit-dialog').find('.recurring-subtitle')
            if ($(this).val()) {
                button.removeClass('hidden2')
                subtitle.removeClass('hidden2')
            } else {
                button.addClass('hidden2')
                subtitle.addClass('hidden2')
            }
        }).trigger('change')
    })
}
